import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const englishWorldManifest: FeatureManifest = {
  id: 'english-world',
  path: 'english-world/*',
  navPath: '/english-world',
  label: 'Nhân vật',
  description: 'Quản lý Thế giới, Nhóm nhân vật và Nhân vật (hồ sơ & ngoại hình)',
  navigationGroup: {
    id: 'english-world',
    label: 'Thế giới tiếng Anh',
  },
  load: () => import('./entry'),
}
